<div>
  <form [formGroup]="fgSearch" novalidate>

    <div class="col col-md-8 col-sm-4">

      <div>
        <div *ngIf="category!='species'" class="input-group mb-2">
          <label class="control-label required col-sm-6">What IBRA subregion are your credits from?</label>
          <select formControlName="subregion" (change)="filterTradingGroups($event)" class="form-control col-sm-4">
            <option value="">Select IBRA subregion</option>
            <option *ngFor="let subregion of subregions" [value]="subregion.name">{{subregion.name}}</option>
          </select>
          
        </div>
      </div>
      <div class="input-group mb-2" *ngIf="category=='ecosystem'">
        <label class="control-label col-sm-6">What PCT ID are your credits?</label>
        <input type="text" formControlName="creditId" class="form-control col-sm-4" maxlength="10" />
      </div>
      <div class="input-group mb-2" *ngIf="category=='species'">
        <label class="control-label col-sm-6">What Species are you interested in?</label>
        <input type="text" formControlName="creditName" class="form-control col-sm-4" maxlength="50" />
      </div>
      <div class="input-group mb-2" *ngIf="category=='ecosystem'">
        <label class="control-label col-sm-6">What Offset Trading Group are your credits?</label>
        <select formControlName="offsetTradingGroup" class="form-control col-sm-4">
          <option value="">Select Offset Trading Group</option>
          <option *ngFor="let tg of filteredTgGroups" [value]="tg">{{tg}}</option>
        </select>
      </div>
      <div class="input-group mb-2" *ngIf="category=='ecosystem'">
        <label class="control-label col-sm-6">Does the vegetation have hollow-bearing trees?</label>
        <select formControlName="hbt" class="form-control col col-sm-4">
          <option value="">Select an option</option>
          <option value="true">Yes</option>
          <option value="false">No</option>
        </select>
      </div>
      <div class="input-group mb-2">
        <label class="control-label col-sm-6">&nbsp;</label>
        <button class="btn btn-primary" [disabled]="!enableSearch" (click)="search();">Search</button>
        <small class="text-danger ml-2 py-2"  *ngIf="!enableSearch">Select any IBRA Subregion from the list.</small>
      </div>
    </div>

  </form>
  <div class="col col-md-12 col-sm-8">
    <form [formGroup]="fgResults" novalidate>
      <div formArrayName="resultsArray">
        <table class="table">
          <thead>
            <tr class="thead-light">
              <th>Select</th>
              <th nowrap>IBRA Region</th>
              <th nowrap>IBRA Subregion</th>
              <th nowrap>{{creditIdLabel}} ID</th>
              <th>Name</th>
              <th>Offset Trading Group</th>
              <th *ngIf="category == 'ecosystem'">HBT?</th>
              <th nowrap>No. of BAM Credits</th>

            </tr>
          </thead>
          <tbody >
            <tr *ngFor="let credit of wantedCredits| paginate: { itemsPerPage: 25, currentPage: p};let i=index">
              <td><div class="form-check"><input type="checkbox" [formControlName]="i" (change)="checkSelectedCredits($event,credit.id)" [checked]="false" class="form-check-input" /></div></td>
              <td>{{credit.ibraRegion}}</td>
              <td>{{credit.ibraSubregion}}</td>
              <td>{{credit.creditId}}</td>
              <td>{{credit.name}}</td>
              <td>{{credit.offsetTradingGroup}}</td>
              <td *ngIf="category == 'ecosystem'">{{credit.hbt!=null && credit.hbt?"yes":"No"}}</td>
              <td>{{credit.numberOfCredits}}</td>

            </tr>
            <tr *ngIf="wantedCredits?.length<=0"><td colspan="8" class="text-center text-info">No results found</td></tr>
          </tbody>
        </table>
        <pagination-controls (pageChange)="p=$event" *ngIf="wantedCredits?.length"></pagination-controls>
      </div>
    </form>
    <app-export-file *ngIf="wantedCredits?.length && allowDownload" [parentPageName]="'Wanted-Credits'"
                     [headerJson]="category == 'ecosystem'?headerJson:headerJsonSpecies" [list]="wantedCredits"></app-export-file>
  </div>
</div>
